import { render, staticRenderFns } from "./MobileFooter.vue?vue&type=template&id=0cdd19b3"
import script from "./MobileFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileFooter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MobileFooter.vue?vue&type=style&index=0&id=0cdd19b3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports